import axios from "axios";
import upLoad from '@/assets/img/screenshoot_upload.png';
import CONFIG from "@/assets/js/config.js";
import SettingPage from "@/controllers/setting/setting-page.js";

export default{
  ...SettingPage,
  name: "CustomSettingPage",

  data() {
    return {
      ...SettingPage.data(),
      settings: {
        teacher_chat_approval: false,
        send_notice_notifications: false,
        allow_referral_discount: false,
        use_facebook_page: false,
        signature: upLoad,
        facebook_integration : false,
        currency: null,
        report_card_grading: null,
        school_start_time: null,
        school_end_time: null,
        employee_attendance_qr: null,
        client_type: null,
        payment_slip_size: 0,
        tax_rate: 0,
        discount_limit: 0,
      }
    };
  },

  methods: {
    ...SettingPage.methods,
    getSetting() {
      this.isLoading = true;
      axios
        .get("/setting/" + this.$store.state.user.campus_id)
        .then((response) => {
          this.settings.teacher_chat_approval = response.data.teacher_chat_approval == 1 ? true : false;
          this.settings.send_notice_notifications = response.data.send_notice_notifications == 1 ? true : false;
          this.settings.allow_referral_discount = response.data.allow_referral_discount == 1 ? true : false;
          this.settings.facebook_integration = response.data.facebook_integration == 1 ? true : false;
          this.settings.use_facebook_page = response.data.use_facebook_page == 1 ? true : false;
          this.settings.signature = response.data.signature == null ? upLoad : response.data.signature;
          this.settings.currency = response.data.currency || null;
          this.settings.report_card_grading = response.data.report_card_grading ?? null;
          this.settings.school_start_time = response.data.school_start_time ?? null;
          this.settings.school_end_time = response.data.school_end_time ?? null;
          this.settings.employee_attendance_qr = response.data.employee_attendance_qr ?? null;
          this.settings.client_type = CONFIG.CLIENT_TYPE[response.data.client_type] || null;
          this.settings.payment_slip_size = response.data.payment_slip_size ?? 0;
          this.settings.tax_rate = response.data.tax_rate ?? 0;
          this.settings.discount_limit = response.data.discount_limit ?? 0;
          this.settings.section_hourly_setting = this.normalizeSectionHourlySetting(response.data.section_hourly_setting);
          this.settings.access_late_minute = response.data.access_late_minute ?? null;
          this.getReportCardGrading(this.settings.report_card_grading);
          this.isLoading = false;
        })
        .catch((error) => {
            if (error.response && error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
            }
        });
    },
  }
}
